import { render, staticRenderFns } from "./myDelegate.vue?vue&type=template&id=2984cafc&scoped=true&"
import script from "./myDelegate.vue?vue&type=script&lang=js&"
export * from "./myDelegate.vue?vue&type=script&lang=js&"
import style0 from "./myDelegate.vue?vue&type=style&index=0&id=2984cafc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2984cafc",
  null
  
)

export default component.exports